export { EquipmentWizard as default } from './equipment-wizard';
